import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=7930d6b7&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7930d6b7",
  null
  
)

export default component.exports